/*
 * @Autor: lianxiben
 * @Date: 2021-05-25 14:16:10
 * @LastEditors: lianxiben
 */
// const masterUrl = window.location.href;
// const domain = masterUrl.split("/")[2];

const hostname = window.location.hostname;
const domain = hostname.split(".")[1];

const base = {
  // h5.qingcijoy.com  api.qingcijoy.com  "//api.qingcigame.com"
  url: domain == "qingcigame" ? "//api.qingcigame.com" : "//api.qingcijoy.com",
};

export default base;
